const localeMap: { [key: string]: string } = {
  "en-US": "en_US",
  "fr-FR": "fr",
  "es-ES": "es",
  "da-DK": "da",
  "de-DE": "de",
  "it-IT": "it",
  "nl-NL": "nl_NL",
  "sv-SE": "sv",
  "en-GB": "en_US",
};

export const convertToSalesforceLocale = (locale: string): string => {
  return localeMap[locale] || locale;
};
